// The full V2 app URL per region, used when the API has not supplied a
// per-org migration URL (the stuck state this banner exists for).
export const REGION_V2_URLS = {
  AU: 'https://next.freshclinics.com.au',
  US: 'https://next.freshclinics.com',
};

export function regionV2Url(region) {
  return REGION_V2_URLS[region] || null;
}

// A real per-org/login URL wins; otherwise fall back to the region constant.
// Returns null when neither is known, which hides the banner.
export function resolveV2Url(orgPlatformUrl, region) {
  return orgPlatformUrl || regionV2Url(region) || null;
}
